export const PHONE_PATTERN =
  '^[+]?[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{4,6}$';
export const NUMBER_PATTERN = '([0-9]*)';
export const SWISS_POSTAL_CODE_PATTERN = '^\\d{4}$';
export const WELCOME_ROUTE_PATH = 'welcome';
